import { Component, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActiveCountries, ActiveSuppliers } from '../Models/ActiveClasses';
import { AirlineMasterProperties } from '../Models/AirlineMasterProperties';
import { FlightSearchAirports } from '../Models/FlightSearchProperties';
import { ChatForm, ChatMessages, OfflineBookingRequestGet } from '../Models/OfflineBookingRequestProperties';
import { OfflineBookingNewPassengerDetails, OfflineBookingNewProperties, OfflineTripDetailsNew } from '../Models/OfflineNewProperties';
import { FileView } from '../offlineBookingRequest/offlineBookingRequest.component';
import { AirlineMasterService } from '../Services/airline-master.service';
import { FlightSearchService } from '../Services/FlightSearch.service';
import { OfflineBookingRequestService } from '../Services/OfflineBookingRequest.service';
import { PassengerInfoService } from '../Services/passengerInfo.service';
import { saveAs as importedSaveAs } from "file-saver";
import { OfflineRequestService } from '../Services/offline-request.service';
import { MessageService } from 'primeng/api';
import { OfflinesuppliersService } from '../Services/offlinesuppliers.service';
import { OfflineSuppAndOfflineOfficeProperties, OfflineSupplierProperties } from '../Models/OfflineSupplierProperties';
import { RevenueManagementService } from '../Services/revenue-management.service';
import { interval } from 'rxjs';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { log } from 'console';
import { GroupTicketService } from '../Services/groupTicket.service';
import { TicketSuppliersAccessCodeProperties } from '../Models/GroupTicketProperties';
import { PassengerProfile, TelephonePassengerProperties } from '../Models/BookingPassengerTicketIssuanceProperties';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Countries } from '../Models/Countries';
@Component({
  selector: 'app-offline-new',
  templateUrl: './offline-new.component.html',
  styleUrls: ['./offline-new.component.scss']
})
/** OfflineNew component*/
export class OfflineNewComponent {
  ctc_num: any;
  /** OfflineNew ctor */
  constructor(private modalService: NgbModal,private groupservice: GroupTicketService,private router: Router, private revenueService: RevenueManagementService, private offlineSupplierservice: OfflinesuppliersService, private airlineservice: AirlineMasterService, private flightService: FlightSearchService, private userService: PassengerInfoService, private senetizer: DomSanitizer
    , private requestService: OfflineBookingRequestService, private service: OfflineRequestService, private messageservice: MessageService) {

  }
  @ViewChild('scrollMe', { static: false }) private myScrollContainer: ElementRef<HTMLDivElement>;
  journeyTypes = [
    { label: 'One Way', value: 1 },
    { label: 'Return', value: 2 },
    { label: 'Multi-City', value: 3 }
  ];
  passengerTypeList = [
    { type: "Adult", value: 1 },
    { type: "Child", value: 2 },
    { type: "Infant", value: 3 },
  ];
  titleOptions = [
    { label: 'Mr', passengerTypes: [1], gender: 'Male' },
    { label: 'Ms', passengerTypes: [1], gender: 'Female' },
    { label: 'Mrs', passengerTypes: [1], gender: 'Female' },
    { label: 'Mstr', passengerTypes: [2, 3], gender: 'Male' },
    { label: 'Miss', passengerTypes: [2, 3], gender: 'Female' }
  ];

  cabinClassList = [
    { cabinType: "FirstClass" },
    { cabinType: "Business" },
    { cabinType: "Economy" },
    { cabinType: "PremiumEconomy" }
    //{ cabinType: "Economy Class" },
  ];
  rbdList = [
    { rbdType: "A" },
    { rbdType: "B" },
    { rbdType: "C" },
    { rbdType: "D " },
    { rbdType: "E" },
    { rbdType: "F" },
    { rbdType: "G" },
    { rbdType: "H" },
    { rbdType: "I" },
    { rbdType: "J" },
    { rbdType: "K" },
    { rbdType: "L" },
    { rbdType: "M" },
    { rbdType: "N" },
    { rbdType: "O" },
    { rbdType: "P" },
    { rbdType: "Q" },
    { rbdType: "R" },
    { rbdType: "S" },
    { rbdType: "T" },
    { rbdType: "U" },
    { rbdType: "V" },
    { rbdType: "W" },
    { rbdType: "X" },
    { rbdType: "Y" },
    { rbdType: "Z" },

  ];
  searchprofileCred: PassengerProfile[];
  attachedFileName: string[] = [];
  chatMessages: ChatMessages[] = [];
  chatForm = new ChatForm();
  offlineBookingRequestOpenByManager: boolean = false;
  chatButtonDisabeld: boolean = false;
  newChatForm = new FormData();
  timeIntervalSet: Subscription;
  roeSubmission: boolean = false;
  loader: boolean = false;
  requestingAgency: string = "";
  OfflineType: string = "";
  fromRoute: string = "";
  isFormDisabled: boolean = false;
  viewFilesDownload: boolean = false;
  viewFilesUpload: boolean = false;
  type: string = "";
  request: string = "";
  supplierList: ActiveSuppliers[] = [];
  officeidListForBind: TicketSuppliersAccessCodeProperties[] = [];
  airlineMasterinfo: AirlineMasterProperties[] = [];
  airportList: FlightSearchAirports[] = [];
  countryList: ActiveCountries[] | undefined;
  countryListFlag: Countries[] = [];
  offlineObj = new OfflineBookingNewProperties();
  filteredAirportsOW: string[] = [];
  offlineTicketRequestFiles: File[] = [];
  previewFileList: FileView[] = [];
  paxFiles: FileList = undefined;
  offlineSupplierList: OfflineSupplierProperties[] = [];
  offlineBookingParam = new OfflineBookingRequestGet();
  ngOnInit() {
    this.fromRoute = localStorage.getItem('fromOfflineRequestRoute');
    this.requestingAgency = localStorage.getItem('requestingAgency');
    this.getCountries();
    console.log(localStorage.getItem('RequestTypeOffline'));
    let type = localStorage.getItem('RequestTypeOffline');
    this.getOfflineSuppliers();
    if (type != "Create") {
      this.OfflineBookingDataGet();
    }
    this.SetFieldsRestrictions();
    this.GetAirlineData();
    this.getBaseData();


    let idRequest: number = Number(localStorage.getItem("RequestTypeIdFromOffline"));
    if (idRequest == 3) {
      this.OfflineType = "Ticket";
    }
    else if (idRequest == 4) {
      this.OfflineType = "Void";
    }
    else if (idRequest == 5) {
      this.OfflineType = "Refund";
    }

  }
  private ChatMessagesCommunicationOfflineTicketGet = (offlineBookingId: number, check: boolean): void => {
    this.service.ChatMessagesCommunicationOfflineTicketGet(offlineBookingId).subscribe(chatList => {
      this.chatMessages = chatList;
      if (check) {
        this.ScrollerChat();
      }
   
    })

  }
  getCountries() {
    try {
      this.userService.getCountries().subscribe((data) => {
        this.countryListFlag = data;

      });
    }
    catch (e) {
      console.log(e);
    }
  }
  OfflineBookingDataGet() {
    this.offlineBookingParam.offlineBookingRequestID = Number(localStorage.getItem('offlineBookingId'));
    this.offlineBookingParam.agencyId = localStorage.getItem("AgencyId");
    this.offlineBookingParam.userId = Number(localStorage.getItem("UserId"));
    this.offlineBookingRequestOpenByManager = JSON.parse(localStorage.getItem("OfflineBookingRequestOpenBy"));
    if (this.offlineBookingRequestOpenByManager == true) {
      this.offlineBookingParam.statusOpen = true;
      this.offlineBookingParam.managerId = Number(localStorage.getItem("UserId"));
    }
    else {
      this.offlineBookingParam.statusOpen = false;
      this.offlineBookingParam.managerId = 0;
    }
    this.loader = true;
    this.service.GetOfflineBookingById(this.offlineBookingParam).subscribe((data) => {
      console.log(data);
      this.loader = false;
      if (data != null && data != undefined) {
        let offline = data;
        if (offline.offlinePassengerList != null && offline.offlinePassengerList != undefined) {
          for (let g = 0; g < offline.offlinePassengerList.length; g++) {
            offline.offlinePassengerList[g].telephoneList = new TelephonePassengerProperties();
            let findcoc = offline.offlinePassengerList[g].mobileNo.split("+")[1].substring(0, 2);
            let findcocbyt = offline.offlinePassengerList[g].mobileNo.split("+")[1].substring(0, 3);
            if (findcoc != null && findcoc != undefined && findcoc != "") {
              let finded = this.countryListFlag.find(ft => ft.countryAccessCode == findcoc);
              if (finded != null && finded != undefined) {
                offline.offlinePassengerList[g].telephoneList.countryAccessCode = finded.countryAccessCode;
                offline.offlinePassengerList[g].telephoneList.flag = finded.flagsImages;
                offline.offlinePassengerList[g].telephoneList.phoneNumber = offline.offlinePassengerList[g].mobileNo.split("+")[1].substring(2);
              }
              else {
                offline.offlinePassengerList[g].telephoneList.countryAccessCode = findcoc;
                offline.offlinePassengerList[g].telephoneList.phoneNumber = offline.offlinePassengerList[g].mobileNo.split("+")[1].substring(2);
              }

            }
            else if (findcocbyt != null && findcocbyt != undefined && findcocbyt != "") {
              let finded = this.countryListFlag.find(ft => ft.countryAccessCode == findcocbyt);
              if (finded != null && finded != undefined) {
                offline.offlinePassengerList[g].telephoneList.countryAccessCode = finded.countryAccessCode;
                offline.offlinePassengerList[g].telephoneList.flag = finded.flagsImages;
                offline.offlinePassengerList[g].telephoneList.phoneNumber = offline.offlinePassengerList[g].mobileNo.split("+")[1].substring(3);
              }
              else {
                offline.offlinePassengerList[g].telephoneList.countryAccessCode = findcocbyt;
                offline.offlinePassengerList[g].telephoneList.phoneNumber = offline.offlinePassengerList[g].mobileNo.split("+")[1].substring(3);
              }
            }
            
          }
        }
        
        this.offlineObj = data;
        this.offlineObj.offlinePassengerList
        this.SetFieldsRestrictions();
        if (this.offlineObj.bookingSource.includes("OFS")) {
          let offlinepcc = this.offlineSupplierList.find(uy => uy.offlineSupplierId == this.offlineObj.bookingSource);
          for (let h = 0; h < offlinepcc.officeSupplierList.length; h++) {
            let ticketspprop = new TicketSuppliersAccessCodeProperties();
            ticketspprop.officeId = offlinepcc.officeSupplierList[h].offlinePcc;
            ticketspprop.currencyName = offlinepcc.officeSupplierList[h].currency;
            this.officeidListForBind.push(ticketspprop);

          }


          
        }
        else {
          this.groupservice.GetTicketAccessCode(this.offlineObj.bookingSource).subscribe(data => {
            this.officeidListForBind = data;


          });
        }
     
        this.ChatMessagesCommunicationOfflineTicketGet(this.offlineObj.offlineBookingId, true);
        this.timeIntervalSet = interval(10000).subscribe(() => {
          this.ChatMessagesCommunicationOfflineTicketGet(this.offlineObj.offlineBookingId, false);
        })
        setTimeout(() => {
          if (this.fromRoute == "managerOfflineRequestList") {
            if (this.offlineObj.status == 1) {
              this.service.InprogressTicketupdate(this.offlineObj.offlineBookingId).subscribe(() => {
                this.router.navigateByUrl("/managerOfflineRequestList");
              })
            }
          }
        }, 500000);
      }
    });
  }
  SetFieldsRestrictions() {
    this.request = localStorage.getItem('RequestActionOffline') || "";
    this.type = localStorage.getItem('RequestTypeOffline') || "";
    if (this.request == "User") {

      //requested status
      if (this.type == "View" && (this.offlineObj.status == 1 || this.offlineObj.status == 3)) {
        this.offlineObj.isManager = false;
        this.viewFilesDownload = true;
        console.log(this.viewFilesDownload);
      }
      //approved or reject status
      else if (this.type == "View" && this.offlineObj.status == 2) {
        this.isFormDisabled = true;
        this.offlineObj.isManager = false;
        this.viewFilesDownload = true;
      }
      else if (this.type == "Create") {
        if (this.fromRoute === "OfflineRequestList") {
          this.requestingAgency = "......";
        }
        this.offlineObj.isManager = false;
        this.viewFilesUpload = true;
      }
    }

    else if (this.request == "Manager") {

      if (this.type == "Update" && (this.offlineObj.status == 2 || this.offlineObj.status == 3)) {
        this.isFormDisabled = true;
        this.offlineObj.isManager = true;
        this.viewFilesDownload = true;
      }
      else if (this.type == "Update" && this.offlineObj.status == 1) {
        this.isFormDisabled = false;
        this.viewFilesUpload = true;
        this.viewFilesDownload = true;
        this.offlineObj.isManager = true;

      }

    }


  }
  GetAirlineData() {
    this.airlineservice.getAirlinesData().subscribe((data) => {
      if (data.length > 0) {

        this.airlineMasterinfo = data;
      }
    })
  }
  getBaseData() {
    this.flightService.GetFlightBaseData().subscribe((data) => {

      this.airportList = data.airports;

    });
    this.userService.getCountries().subscribe((data) => {
      this.countryList = data;

    });
  }
  getFilteredTitles(passengerType: number) {
    if (passengerType == null) {
      return this.titleOptions;
    }
    this.titleOptions = this.titleOptions.filter(option => option.passengerTypes.includes(passengerType));
    return this.titleOptions;
  }

  public OneWayDepartureFromTicket = (fromAirport: string, index: number): void => {
    this.offlineObj.tripList[index].fromAirport = fromAirport.split("-")[0].trim();

  }
  public OneWayDepartureToTicket = (toAirport: string, index: number): void => {
    this.offlineObj.tripList[index].toAirport = toAirport.split("-")[0].trim();
  }
  public filterAirportsOW = (event: any): void => {
    let filteredOW: string[] = [];
    let query = event.query.toLowerCase();
    for (let i: number = 0; i < this.airportList.length; i++) {
      let airportOW = this.airportList[i];
      if (airportOW.iatA_CODE.toLowerCase().startsWith(query) || airportOW.city.toLowerCase().startsWith(query)) {
        if (airportOW.iatA_CODE.toLowerCase() === query) {
          filteredOW[0] = airportOW.airportName;
        }
        filteredOW.push(airportOW.airportName);
      }
    }
    filteredOW = [...new Set(filteredOW)];
    this.filteredAirportsOW = filteredOW;
  }

  public OnPassengerFileChange = (event: any, eventTrigger: string): void => {
    event.preventDefault();
    {
      if (eventTrigger == "click") {
        this.paxFiles = event.target.files;
        for (let f: number = 0; f < this.paxFiles.length; f++) {
          this.offlineTicketRequestFiles.push(this.paxFiles[f]);
        }
      }
      if (eventTrigger == "drag") {
        this.paxFiles = event.dataTransfer.files;
        for (let f: number = 0; f < this.paxFiles.length; f++) {
          this.offlineTicketRequestFiles.push(this.paxFiles[f]);
        }
      }
      //this.previewFileList = [];
      for (let i: number = 0; i < this.paxFiles.length; i++) {
        const file: File = this.paxFiles.item(i) as File;
        const safePreview = file as FileView;
        if (file) {
          safePreview.showImage = this.senetizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
          this.previewFileList.push(safePreview);
        }
      }
    }
  }
  public ClearSelection = (index: number): void => {
    this.offlineTicketRequestFiles.splice(index, 1);
    this.previewFileList.splice(index, 1);
  }
  public RequestFileDownload = (filePath: string): void => {
    let fileTypeArray: string[] = filePath.split('.');
    let fileType: string = fileTypeArray[fileTypeArray.length - 1];
    if (fileType.includes('pdf')) {
      fileType = 'application/pdf';
    } else {
      fileType = 'image/' + fileType;
    }
    this.requestService.OfflineBookingRequestFileDownload(filePath, fileType).subscribe(
      (data: Blob) => {
        importedSaveAs(data, filePath.split('.')[filePath.split('.').length - 2] + "." + fileType.split('/')[1]);
      }
    )
  }
  public OnDragOver(event: any): void {
    event.preventDefault();
  }
  chatFiles: FileList = undefined;
  public OnFileChange = (event: any, eventTrigger: string): void => {
    event.preventDefault();
    //this.attachedFileName = [];
    //this.chatForm.fileAttached = [];
    if (event.target.files.length == 0) {
      this.attachedFileName = [];
      this.chatForm.fileAttached = [];
    }
    else {
      //let files: FileList = undefined;
      if (eventTrigger == "click") {
        this.chatFiles = event.target.files;
        for (let f: number = 0; f < this.chatFiles.length; f++) {
          this.chatForm.fileAttached.push(this.chatFiles[f]);
        }
      }
      if (eventTrigger == "drag") {
        this.chatFiles = event.dataTransfer.files;
        for (let f: number = 0; f < this.chatFiles.length; f++) {
          this.chatForm.fileAttached.push(this.chatFiles[f]);
        }
      }
    }
    for (let n = 0; n < this.chatForm.fileAttached.length; n++) {
      this.attachedFileName.push(this.chatForm.fileAttached[n].name);
    }
  }
  public OnClearChatSelection = (index: number): void => {
    this.chatForm.fileAttached.splice(index, 1);
    this.attachedFileName.splice(index, 1);
  }
  public ChatRequest = (chatFormData: any): void => {

    this.chatButtonDisabeld = true;
    this.newChatForm = new FormData();
    if (this.chatForm.message == undefined || this.chatForm.message.trim() == "") {
      this.chatForm.message = "**no content**";
    }
    this.chatForm.message = this.chatForm.message.trim();
    this.newChatForm.append("message", this.chatForm.message);
    for (let fa = 0; fa < this.chatForm.fileAttached.length; fa++) {
      this.newChatForm.append("fileAttached" + fa, this.chatForm.fileAttached[fa], this.chatForm.fileAttached[fa].name);
    }
    this.newChatForm.append("offlineRequestBookingId", this.offlineObj.offlineBookingId.toString());
    const timestamp = Date.now();
    const chatTime = new Date(timestamp);
    const formatedChatTime = `${chatTime.getHours().toString().padStart(2, '0')}:${chatTime.getMinutes().toString().padStart(2, '0')} ${chatTime.getDate().toString().padStart(2, '0')}-${(chatTime.getMonth() + 1).toString().padStart(2, '0')}-${chatTime.getFullYear()}`;
    this.newChatForm.append("chatTime", formatedChatTime);
    if (Number(localStorage.getItem("UserId")) == this.offlineObj.creationUser) {
      this.newChatForm.append("userId", this.offlineObj.creationUser.toString());
      this.newChatForm.append("managerId", this.offlineObj.agencyBranchManagerId.toString());
      this.chatForm.isManager = false;
      this.newChatForm.append("isManager", this.chatForm.isManager.toString());
    }
    else if (Number(localStorage.getItem("UserId")) == this.offlineObj.agencyBranchManagerId) {
      this.newChatForm.append("userId", this.offlineObj.creationUser.toString());
      this.newChatForm.append("managerId", this.offlineObj.agencyBranchManagerId.toString());
      this.chatForm.isManager = true;
      this.newChatForm.append("isManager", this.chatForm.isManager.toString());

    }
    this.service.ChatMessagesCommunicationOfflineTicket(this.newChatForm).subscribe(data => {
      this.attachedFileName = [];
      this.chatMessages = data;
      console.log(this.chatMessages);
      this.chatButtonDisabeld = false;
      if (this.chatMessages.length > 0) {
        this.ScrollerChat();
      }
      if (this.chatForm.isManager == true) {
        const form = new FormData();
        form.append("userId", this.offlineObj.creationUser.toString());
        form.append("message", this.chatForm.message);
        form.append("offlineRequestBookingId", this.offlineObj.offlineBookingId.toString());
        this.service.EmailMesage(form).subscribe((data) => { })
        this.chatForm = new ChatForm();
      }
      else {
        this.chatForm = new ChatForm();
      }
    })
  }
  private ScrollerChat = (): void => {
    try {
      if (this.myScrollContainer) {
        this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
      }
    } catch (err) {
    }

  }
  public RejectRequest = (): void => {
    this.offlineObj.status = 3;
    this.service.RejectRequestOfflineBooking(this.offlineObj).subscribe((data) => {
      if (data.success) {
        
        this.messageservice.add({ severity: 'success', summary: 'Successfully!', detail: data.message });
        this.CheckROUTE();
      }
      else {
        this.messageservice.add({ severity: 'error', summary: 'Required', detail: data.message });

      }
    });
  }
  ParseDate = (dateString: string): string => {
    if (dateString) {
      return dateString;
    }
    return null;
  }
  public SubmitData = (dataform: any, approved: boolean): void => {
    this.roeSubmission = true;
    if (dataform.invalid) {
      this.messageservice.add({ severity: 'error', summary: 'Required', detail: 'Fields are Required' });
      return;
    }
    
    
    if (this.offlineObj.offlineBookingId == 0 || this.offlineObj.offlineBookingId == undefined) {
      this.offlineObj.status = 1;
    }
    if (approved) {
      if (this.offlineObj.offlinePassengerList.length == 0) {
        this.messageservice.add({ severity: 'error', summary: 'Required', detail: 'At Least 1 Passenger' });
      }
      if (this.offlineObj.tripList.length == 0) {
        this.messageservice.add({ severity: 'error', summary: 'Required', detail: 'At Least 1 Trip' });
      }
      this.offlineObj.status = 2;
      this.offlineObj.travelDate = this.offlineObj.tripList[0].travelingDate;
      let trip = "";
      if (this.offlineObj.journeyTypeId==1) {
        trip = "OW";
      }
      else if (this.offlineObj.journeyTypeId == 2) {
        trip = "RT";
      }
      else if (this.offlineObj.journeyTypeId == 3) {
        trip = "MT";
      }
      this.offlineObj.sector = this.offlineObj.tripList[0].fromAirport + "-" + this.offlineObj.tripList[this.offlineObj.tripList.length - 1].toAirport + "(" + trip + ")"  ;
      this.offlineObj.passName = this.offlineObj.offlinePassengerList[0].firstName + " " + this.offlineObj.offlinePassengerList[0].lastName;
      this.offlineObj.ticketNo = this.offlineObj.offlinePassengerList[0].ticketNo;
      this.offlineObj.approve_Reject_User = Number(localStorage.getItem("UserId"));
      this.offlineObj.modifyUser = Number(localStorage.getItem("UserId"));
    }
    if (this.request == "Manager") {
      this.offlineObj.isManager = true;
    }
    else {
      this.offlineObj.agency_Branch_Id = (localStorage.getItem("AgencyId"));
      this.offlineObj.offlineRequestTypeId = Number(localStorage.getItem("RequestTypeIdFromOffline"));
      this.offlineObj.creationUser = Number(localStorage.getItem("UserId"));
      this.offlineObj.agencyCurrency = localStorage.getItem("AgencyCurrency");
      this.offlineObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
    }
   
    const currentDate = new Date();
    this.offlineObj.creationDate = currentDate.toISOString().split('T')[0];



    const formData = new FormData();
    formData.append("offlineObj", JSON.stringify(this.offlineObj));
    for (let index = 0; index < this.offlineTicketRequestFiles.length; index++) {
      formData.append(index.toString(), this.offlineTicketRequestFiles[index], this.offlineTicketRequestFiles[index].name);
    }
    this.loader = true;
    this.service.CreateOrUpdateOfflineBooking(formData).subscribe((data) => {
      if (data.success) {
        this.loader = false;
        this.CheckROUTE();
        
        this.messageservice.add({ severity: 'success', summary: 'Successfully!', detail: data.message });
      }
      else {
        this.messageservice.add({ severity: 'error', summary: 'Required', detail: data.message });

      }
    });
  }
  CheckROUTE() {
    if (this.fromRoute == "managerOfflineRequestList") {

      this.router.navigateByUrl("/managerOfflineRequestList");
    }
    else if (this.fromRoute == "offline-my-booking-tkt-list") {
      this.router.navigateByUrl("/offline-my-booking-tkt-list");
    }
    else if (this.fromRoute == "OfflineRequestList") {
      this.router.navigateByUrl("/offlineRequestList");
    }
  }
  getOfflineSuppliers() {
    this.offlineSupplierservice.getOfflineSupplier().subscribe((data) => {
      this.offlineSupplierList = data;
      this.getSuppliers();
    });
  }
  getSuppliers() {
    this.revenueService.GetRevenueManagementSupplierByParent(localStorage.getItem("AgencyId")).subscribe((result) => {
      this.supplierList = result;
      if (this.offlineSupplierList.length > 0) {
        if (this.supplierList == null || this.supplierList == undefined) {
          this.supplierList = [];
        }
        for (let i = 0; i < this.offlineSupplierList.length; i++) {
          let active = new ActiveSuppliers();
          active.name = this.offlineSupplierList[i].offlineSupplierId + " - " + this.offlineSupplierList[i].offlineSupplierName;
          active.supplierId = this.offlineSupplierList[i].offlineSupplierId;
          this.supplierList.push(active);
        }
      }
    });
  }

  OnTripTypeChange() {
    this.offlineObj.tripList = [];
    try {

      if (this.offlineObj.journeyTypeId == 1) {
        let tripobj = new OfflineTripDetailsNew();
        tripobj.creationUser = this.offlineObj.creationUser;
        this.offlineObj.tripList.push(tripobj);

      }
      else if (this.offlineObj.journeyTypeId == 2 || this.offlineObj.journeyTypeId == 3) {
        let tripobj = new OfflineTripDetailsNew();
        tripobj.creationUser = this.offlineObj.creationUser;
        let tripobj1 = new OfflineTripDetailsNew();
        tripobj1.creationUser = this.offlineObj.creationUser;
        this.offlineObj.tripList.push(tripobj, tripobj1);
      }





    }
    catch (ex) {
      console.log(ex);
    }
  }
  RemoveTripDetails(i: number) {
    if (this.offlineObj.journeyTypeId == 1 && this.offlineObj.tripList.length > 1) {
      this.offlineObj.tripList.splice(i, 1);
    }
    if (this.offlineObj.journeyTypeId == 2 && this.offlineObj.tripList.length > 1) {
      this.offlineObj.tripList.splice(i, 1);
    }

    if (this.offlineObj.journeyTypeId == 3 && this.offlineObj.tripList.length >= 3) {
      this.offlineObj.tripList.splice(i, 1);
    }
  }
  DeletePassenger(i: number) {
    if (this.offlineObj.offlinePassengerList.length > 1) {
      this.offlineObj.offlinePassengerList.splice(i, 1);
    }
  }
  AddPassenger() {
    if (this.offlineObj.offlinePassengerList.length <= 8) {
      let passenger = new OfflineBookingNewPassengerDetails();
      passenger.modifyUser = Number(localStorage.getItem("UserId"));
      passenger.creationUser = this.offlineObj.creationUser;
      passenger.agencyBranch = this.offlineObj.agency_Branch_Id;
      this.offlineObj.offlinePassengerList.push(passenger);
    }
    else {
      this.messageservice.add({ severity: 'error', summary: 'Rejected!', detail: "Maximum Added!" });
    }
  }
  AddTripDetails() {
    if (this.offlineObj.tripList.length <= 7) {
      let tripobj = new OfflineTripDetailsNew();
      tripobj.creationUser = this.offlineObj.creationUser;
      tripobj.modifyUser = Number(localStorage.getItem("UserId"));
      this.offlineObj.tripList.push(tripobj);
    }
    else {
      this.messageservice.add({ severity: 'error', summary: 'Rejected!', detail: "Maximum Added!" });
    }
  }
  toTitleCaseOfPass(i, str, e) {
    if (str == undefined) {
      return
    }
    var event = e.target.id;

    var firstname = document.getElementById(`firstName${i}`) as HTMLInputElement;
    var lastname = document.getElementById(`lastName${i}`) as HTMLInputElement;

    var first = firstname.id;
    var last = lastname.id;

    if (event == first) {
      var capitalizefirstname = str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }

      );

      this.offlineObj.offlinePassengerList[i].firstName = capitalizefirstname;
    }
    if (event == last) {
      var capitalizelastname = str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }

      );

      this.offlineObj.offlinePassengerList[i].lastName = capitalizelastname;
    }

  }
  //end
  TitleChange(value: number): boolean {
    if (this.offlineObj.offlinePassengerList[value].title == null || this.offlineObj.offlinePassengerList[value].title == undefined || this.offlineObj.offlinePassengerList[value].title == "" || this.offlineObj.offlinePassengerList[value].title == "Select") {
      this.offlineObj.offlinePassengerList[value].title= null;
      this.messageservice.add({ severity: 'error', summary: 'Rejected!', detail: "Please Select the  Passenger Type!" });
      return false;
    }
    let pass = this.titleOptions.find(option => option.label == this.offlineObj.offlinePassengerList[value].title);
    this.offlineObj.offlinePassengerList[value].paxGender = pass.gender;
  }

  onClickCalculatePayable(i) {
    if (this.offlineObj.offlinePassengerList[i].serviceCharges == null || this.offlineObj.offlinePassengerList[i].serviceCharges == undefined || this.offlineObj.offlinePassengerList[i].serviceCharges < 0) {
      this.offlineObj.offlinePassengerList[i].serviceCharges = 0;
    }
    if (this.offlineObj.offlinePassengerList[i].discount == null ||this.offlineObj.offlinePassengerList[i].discount == undefined ||this.offlineObj.offlinePassengerList[i].discount < 0) {
      this.offlineObj.offlinePassengerList[i].discount = 0;
    }
    if (this.offlineObj.offlinePassengerList[i].fare == null || this.offlineObj.offlinePassengerList[i].fare == undefined ||this.offlineObj.offlinePassengerList[i].fare < 0) {
      this.offlineObj.offlinePassengerList[i].fare = 0;
    }
    if (this.offlineObj.offlinePassengerList[i].tax == null || this.offlineObj.offlinePassengerList[i].tax == undefined ||this.offlineObj.offlinePassengerList[i].tax < 0) {
      this.offlineObj.offlinePassengerList[i].tax = 0;
    }
    this.offlineObj.offlinePassengerList[i].payable = (this.offlineObj.offlinePassengerList[i].serviceCharges + this.offlineObj.offlinePassengerList[i].fare + this.offlineObj.offlinePassengerList[i].tax) - this.offlineObj.offlinePassengerList[i].discount;
  }
  ExchangeRateChange(value: number): boolean {
    if (this.offlineObj.bookingPcc == null || this.offlineObj.bookingPcc == undefined || this.offlineObj.bookingPcc == "") {
      this.offlineObj.exchangeCurrencyRate = null;
      this.messageservice.add({ severity: 'error', summary: 'Rejected!', detail: "Please Enter 1st Booking Pcc!" });
      return false;
    }
    let obj = this.officeidListForBind.find(gt => gt.officeId == this.offlineObj.bookingPcc);
    
    let check = false;
    if (localStorage.getItem('AgencyCurrency') === obj.currencyName) {
      if (value > 1 || value < 1) {

        this.messageservice.add({ severity: 'error', summary: 'Error', detail: 'Exchange Rate must be 1' });
        check = false;
      } else {
        check = true;

      }
    }
    else if (localStorage.getItem('AgencyCurrency') != obj.currencyName) {
      if (localStorage.getItem('AgencyCurrency')  === 'AED') {
        if (value >= 1) {
          this.messageservice.add({ severity: 'error', summary: 'Error', detail: 'Enter value Less than 1.' });
          check = false;
        } else {
          check = true;

        }
      }
      else if (localStorage.getItem('AgencyCurrency') === 'PKR') {
        if (value <= 1) {
          this.messageservice.add({ severity: 'error', summary: 'Error', detail: 'Enter value Greater than 1.' });
          check = false;
        } else {
          check = true;

        }
      }
      

    }
    return check;
  }
  Select_Profiledata(data, targetmodel) {
    try {

      var index = this.searchprofileCred[0].passengerindex;
      
      for (let i = 0; i < this.offlineObj.offlinePassengerList.length; i++) {

        if (index == i) {


            this.offlineObj.offlinePassengerList[i].title = data.title,

            this.offlineObj.offlinePassengerList[i].firstName = data.firstName,
            this.offlineObj.offlinePassengerList[i].lastName = data.lastName,
            this.offlineObj.offlinePassengerList[i].paxGender = data.paxGender,
              this.offlineObj.offlinePassengerList[i].paxDOB = data.paxDOB,
              this.offlineObj.offlinePassengerList[i].mobileNo = data.mobile_No,
              /* this.offlineObj.offlinePassengerList[i].phone = data.phone_No,*/
              this.offlineObj.offlinePassengerList[i].nationality = data.paxNationality,
              /* this.offlineObj.offlinePassengerList[i].passportValidFrom= data.passportValidFrom,*/
              this.offlineObj.offlinePassengerList[i].passportValidTo = data.passportValidTo,
              this.offlineObj.offlinePassengerList[i].passportNo = data.passportNumber,
              this.offlineObj.offlinePassengerList[i].countryOfIssuance = data.countryOfIssuance,
              this.offlineObj.offlinePassengerList[i].emailId = data.email_Id,
            this.offlineObj.offlinePassengerList[i].frequentFlyerNo = data.frequent_Flyer_No,

            //this.mobile = data.mobile_No;
            //this.email = data.email_Id;
            //this.phone = data.phone_No;
            //console.log(this.offlineObj.offlinePassengerList);


            this.modalService.dismissAll(targetmodel);
        }
      }
    }

    catch (e) { console.log(e); }
  }

  SearchCtcNo(targetmodel, i) {
    if (this.offlineObj.offlinePassengerList[i].telephoneList != null) {
      if (this.offlineObj.offlinePassengerList[i].telephoneList.countryAccessCode != null && this.offlineObj.offlinePassengerList[i].telephoneList.countryAccessCode != undefined &&
        this.offlineObj.offlinePassengerList[i].telephoneList.countryAccessCode != "" && this.offlineObj.offlinePassengerList[i].telephoneList.phoneNumber != null && this.offlineObj.offlinePassengerList[i].telephoneList.phoneNumber != undefined &&
        this.offlineObj.offlinePassengerList[i].telephoneList.phoneNumber != "") {
        this.ctc_num = "+" + this.offlineObj.offlinePassengerList[i].telephoneList.countryAccessCode + this.offlineObj.offlinePassengerList[i].telephoneList.phoneNumber;
        this.offlineObj.offlinePassengerList[i].mobileNo = "+" + this.offlineObj.offlinePassengerList[i].telephoneList.countryAccessCode + this.offlineObj.offlinePassengerList[i].telephoneList.phoneNumber;
      }
    }
    var ctc_number = { ctcno: this.ctc_num }
    if (this.MobileNumberValidateWhenSearch(i) == false) {
      return;
    }
    try {

      this.userService.GetPassengerProfileSearch(ctc_number).subscribe((data) => {


        let Searchpassenger = [];
        /* this.searchprofileCred = data;*/

        Searchpassenger = data;
        for (let i = 0; i < Searchpassenger.length; i++) {
          if (Searchpassenger[i].passengerType == 1) {
            Searchpassenger[i].passengerTypeName = "Adult";
          }
          else if (Searchpassenger[i].passengerType == 2) {
            Searchpassenger[i].passengerTypeName = "Child";
          }
          else if (Searchpassenger[i].passengerType == 3) {
            Searchpassenger[i].passengerTypeName = "Infant";
          }
        }
        this.searchprofileCred = Searchpassenger;
        for (let j = 0; j < this.searchprofileCred.length; j++) {
          this.searchprofileCred[j].passengerindex = i;
        }
        //console.log(this.searchprofileCred.passengerindex);
        if (this.searchprofileCred.length > 0) {
          this.modalService.open(targetmodel, {

            /*          windowClass: "searchpassengerpopupmodal"*/
            //scrollable: true,
            //size: 'modal-xl',
            size: 'lg',
          })
        }

        //console.log(data);

      });
    }
    catch (e) {
      console.log(e);
    }

  }
  getSearchonfocusout(targetmodel, i) {
    if (this.offlineObj.offlinePassengerList[i].telephoneList != null) {
      if (this.offlineObj.offlinePassengerList[i].telephoneList.countryAccessCode != null && this.offlineObj.offlinePassengerList[i].telephoneList.countryAccessCode != undefined &&
        this.offlineObj.offlinePassengerList[i].telephoneList.countryAccessCode != "" && this.offlineObj.offlinePassengerList[i].telephoneList.phoneNumber != null && this.offlineObj.offlinePassengerList[i].telephoneList.phoneNumber != undefined &&
        this.offlineObj.offlinePassengerList[i].telephoneList.phoneNumber != "") {
        this.ctc_num = "+" + this.offlineObj.offlinePassengerList[i].telephoneList.countryAccessCode + this.offlineObj.offlinePassengerList[i].telephoneList.phoneNumber;
        this.offlineObj.offlinePassengerList[i].mobileNo = "+" + this.offlineObj.offlinePassengerList[i].telephoneList.countryAccessCode + this.offlineObj.offlinePassengerList[i].telephoneList.phoneNumber;
      }
    }
    var ctc_number = { ctcno: this.ctc_num }
    if (this.MobileNumberValidateWhenSearch(i) == false) {
      return;
    }
    try {

      this.userService.GetPassengerProfileSearch(ctc_number).subscribe((data) => {

        let Searchpassenger = [];
        /* this.searchprofileCred = data;*/

        Searchpassenger = data;
        for (let i = 0; i < Searchpassenger.length; i++) {
          if (Searchpassenger[i].passengerType == 1) {
            Searchpassenger[i].passengerTypeName = "Adult";
          }
          else if (Searchpassenger[i].passengerType == 2) {
            Searchpassenger[i].passengerTypeName = "Child";
          }
          else if (Searchpassenger[i].passengerType == 3) {
            Searchpassenger[i].passengerTypeName = "Infant";
          }
        }
        this.searchprofileCred = Searchpassenger;
        for (let j = 0; j < this.searchprofileCred.length; j++) {
          this.searchprofileCred[j].passengerindex = i;
        }

        if (this.searchprofileCred.length > 0) {
          this.modalService.open(targetmodel, {

            /*   windowClass: "searchpassengerpopupmodal"*/
            //scrollable: true,
            size: 'lg',
          })
        }


      });
    }
    catch (e) {
      console.log(e);
    }

  }  //end
  MobileNumberValidateWhenSearch(i) {

    //var mobile = document.getElementById(`mobilenumbervalidate${i}`) as HTMLInputElement;

    /* var pattern = "@^(\+\d{1,2})?\(?\d{3}\)?\d{3}\d{4}$@";*/
    var pattern = /^\+\d{3}?\d+$/;
    if (this.offlineObj.offlinePassengerList[i].mobileNo.match(pattern)) {

      document.getElementById(`messagepass${i}`).innerHTML = '';
      return true;
    }
    else {

      document.getElementById(`messagepass${i}`).innerHTML = 'Please Follow the Pattern of Mobile Number';
      return false;
    }
    return false;
  }
  CountryAccesCode(index: number) {
    if (this.offlineObj.offlinePassengerList[index].telephoneList == null || this.offlineObj.offlinePassengerList[index].telephoneList == undefined) {
      this.offlineObj.offlinePassengerList[index].telephoneList = new TelephonePassengerProperties();
    }
    this.offlineObj.offlinePassengerList[index].telephoneList.phoneNumber = "";
    this.offlineObj.offlinePassengerList[index].mobileNo = "";
    if (this.offlineObj.offlinePassengerList[index].telephoneList.countryAccessCode != null &&
      this.offlineObj.offlinePassengerList[index].telephoneList.countryAccessCode != undefined && this.offlineObj.offlinePassengerList[index].telephoneList.countryAccessCode != "") {
      this.offlineObj.offlinePassengerList[index].telephoneList.mask = "";

      let country = this.countryListFlag.find(f => f.countryAccessCode == this.offlineObj.offlinePassengerList[index].telephoneList.countryAccessCode);
      this.offlineObj.offlinePassengerList[index].telephoneList.country = country.code;
      this.offlineObj.offlinePassengerList[index].telephoneList.flag = country.flagsImages;
      let findlength = 20;

      findlength = country.mobileNoLength - country.countryAccessCode.length;
      for (let g = 0; g < findlength; g++) {
        this.offlineObj.offlinePassengerList[index].telephoneList.mask += "9";
      }
    }
  }
  ApplyRevenue(dataform) {
    this.roeSubmission = true;
    if (dataform.invalid) {
      this.messageservice.add({ severity: 'error', summary: 'Required', detail: "Fields Are Required" });

      return;
    }
    this.service.ApplyRevenueOnTicketPassengerWise(this.offlineObj).subscribe((data) => {
      if (data != null) {
        for (let r = 0; r < this.offlineObj.offlinePassengerList.length;r++) {
          for (let o = 0; o < data.offlinePassengerList.length; o++) {
            if (this.offlineObj.offlinePassengerList[r].firstName == data.offlinePassengerList[o].firstName
              && this.offlineObj.offlinePassengerList[r].lastName == data.offlinePassengerList[o].lastName
              && this.offlineObj.offlinePassengerList[r].passengerTypeId == data.offlinePassengerList[o].passengerTypeId) {
              this.offlineObj.offlinePassengerList[r].serviceCharges = data.offlinePassengerList[o].serviceCharges;
              this.offlineObj.offlinePassengerList[r].discount = data.offlinePassengerList[o].discount;
              this.onClickCalculatePayable(r);
              break;
            }
          }
        }
    
      }
      else {
        this.messageservice.add({ severity: 'warn', summary: 'Revenue', detail: "Not Applied" });

      }
    });
  }
}
